import React, { FC, ReactNode } from 'react'
import LKButton from '../../../../shared/LKButton'
import LKModal, { LKModalContainer, LKModalTrigger } from '../../../../shared/LKModal'
import { LocalSearchGrid } from '../../../../shared/Helpers'
import LKGridConfig from './LKGridConfig'
import translate from './translate'
import container from '../container'
import { AccountPermissionAddProps, LookupsData } from 'src/features/AccountDetails/AccountDetails.types'

// @ts-ignore
@LKModalContainer('AccountPermissionAdd')
@container
class AccountPermissionAdd extends React.Component<AccountPermissionAddProps> {
  state: {
    permissionID: number
    filtered: LookupsData[]
  } = {
    permissionID: undefined,
    filtered: [],
  }

  componentDidMount() {
    this.handleModalOpen()
  }

  handleModalOpen = () => {
    const filtered = this.props.lookups.filter((permission) => {
      if (permission.Active === 0) {
        return false
      }

      return permission.ID > 0
    })

    this.setState({ filtered })
  }

  handleInputChange = (filtered: LookupsData[]) => {
    if (!filtered.length) {
      this.setState({ permissionID: undefined })
    }
  }

  handleRowSelection = (gridRow: {
    node: {
      data: LookupsData
      selected: boolean
    }
  }) => {
    const {
      node: {
        data: { ID },
        selected,
      },
    } = gridRow

    if (selected) {
      this.setState({ permissionID: ID })
    }
  }

  handleSubmit = () => {
    this.props.addPermission(this.state.permissionID)
  }

  render() {
    const { modalInstanceName, lookups, handleModalClose, loading } = this.props
    const { filtered } = this.state

    return (
      // @ts-ignore
      <LKModal
        name={modalInstanceName}
        heading={translate('frm_sec_RL_add_edit')}
        loading={!lookups}
        onClose={handleModalClose}
        size="sm-1"
        footer={
          // @ts-ignore
          <LKModal.Footer>
            {/** @ts-ignore */}
            <LKButton alias="add" onClick={this.handleSubmit} loading={loading} disabled={loading}>
              {translate('cmd_finish')}
            </LKButton>
            {/** @ts-ignore */}
          </LKModal.Footer>
        }
      >
        <LocalSearchGrid
          data={filtered}
          LKGridConfig={LKGridConfig}
          onRowSelected={this.handleRowSelection}
          searchBy="LoginFull"
          onInputChange={this.handleInputChange}
        />
      </LKModal>
    )
  }
}

export const AccountPermissionAddTrigger: FC<{ children: ReactNode }> = ({ children }) => (
  // @ts-ignore
  <LKModalTrigger alias="add" name="AccountPermissionAdd">
    {children}
  </LKModalTrigger>
)

export default AccountPermissionAdd
